import React from 'react';
import cx from 'classnames';

import { Body1, Heading6 } from '../Typography';

import { ReactComponent as CheckmarkWhite } from '../../assets/svg/checkmark-white.svg';
import { ReactComponent as CheckmarkGreen } from '../../assets/svg/checkmark-green.svg';

import styles from './index.module.scss';

export interface CheckmarkListItemProps {
  title?: string;
  text?: string;
  isCheckmarkWhite?: boolean;
  className?: string;
}

const CheckmarkListItem: React.FC<CheckmarkListItemProps> = ({
  isCheckmarkWhite,
  title,
  text,
  className,
}) => {
  return (
    <li className={cx(styles.wrapper, className)}>
      {isCheckmarkWhite ? (
        <CheckmarkWhite className={styles.icon} />
      ) : (
        <CheckmarkGreen className={styles.icon} />
      )}
      <div
        className={cx(styles.textWrapper, {
          [styles.textWhite]: isCheckmarkWhite,
        })}
      >
        {title && <Heading6 className={styles.title}>{title}</Heading6>}
        <Body1>{text}</Body1>
      </div>
    </li>
  );
};

export default CheckmarkListItem;
